<template>
  <div class="v2-products v2-container v2-section">
    <header class="v2-products__header">
      <div class="v2-products__title-block">
        <p class="v2-overline">Membresía</p>
        <h1 class="v2-headline v2-headline--display-lg v2-products__title">
          Productos y servicios
        </h1>
        <p class="v2-body v2-body--md v2-body--muted">
          Explora los productos disponibles o revisa tus compras anteriores.
        </p>
      </div>
    </header>

    <v-tabs v-model="activeTab" color="#1b273e" class="v2-products__tabs mb-4">
      <v-tab class="text-none">Disponibles</v-tab>
      <v-tab class="text-none">Mis compras</v-tab>
    </v-tabs>

    <v-tabs-items v-model="activeTab">
      <v-tab-item>
        <MemberProductsServicesBlock />
      </v-tab-item>
      <v-tab-item>
        <div class="v2-products__purchased">
          <MemberPurchasedProductsBlock />
        </div>
      </v-tab-item>
    </v-tabs-items>
  </div>
</template>

<script>
import { mapState } from "vuex";
import MemberProductsServicesBlock from "@/components/memberDashboard/MemberProductsServicesBlock.vue";
import MemberPurchasedProductsBlock from "@/components/memberDashboard/MemberPurchasedProductsBlock.vue";

export default {
  name: "MemberProductsV2",
  components: { MemberProductsServicesBlock, MemberPurchasedProductsBlock },
  data() {
    return {
      activeTab: 0,
    };
  },
  computed: {
    ...mapState("user", ["user"]),
  },
};
</script>

<style scoped>
.v2-products__header {
  margin-bottom: var(--space-6);
}

.v2-products__title-block {
  display: flex;
  flex-direction: column;
  gap: var(--space-2);
}

.v2-products__tabs {
  border-bottom: 1px solid var(--color-border, rgba(30, 46, 62, 0.1));
}

.v2-products__purchased {
  margin-top: var(--space-4);
}
</style>
